import * as React from 'react';

export interface ITextboxProps {
    id: string;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FormEvent<HTMLInputElement>) => void;
    labelText?: string;
    placeHolder?: string;
    required?: boolean;
    value: string;
    autoFocus?: boolean;
    type?: string;
    disabled?: boolean;
}

export class Textbox extends React.Component<ITextboxProps, any> {
    static defaultProps = {
        onInput: () => { },
        onKeyPress: () => { },
        onKeyDown: () => { },
        onBlur: () => { },
        onFocus: () => { },
        labelText: '',
        value: '',
        placeHolder: '',
        required: false,
        autoFocus: false,
        type: 'text',
        disabled: false,
    }

    onInputHandler(e: React.FormEvent<HTMLInputElement>) {
        this.props.onInput(e);
    }

    onKeyPressHandler(e: any) {
        this.props.onKeyPress(e);
    }

    onKeyDownHandler(e: any) {
        this.props.onKeyDown(e);
    }

    onBlurHandler(e: any) {
        this.props.onBlur(e);
    }

    onFocusHandler(e: any) {
        this.props.onFocus(e);
    }

    render() {
        const { value, placeHolder, labelText, required, id, autoFocus, type } = this.props;

        let boundInput = this.onInputHandler.bind(this);
        let boundKeyPress = this.onKeyPressHandler.bind(this);
        let boundonKeyDown = this.onKeyDownHandler.bind(this);
        let boundOnBlur = this.onBlurHandler.bind(this);
        let boundOnFocus = this.onFocusHandler.bind(this);

        return (
            <React.Fragment>
                <label htmlFor={id} className='visually-hidden'>
                    <span >{labelText}</span>
                </label>
                <input type={type ? type : 'text'} id={id}
                    autoFocus={autoFocus}
                    onChange={boundInput}
                    onKeyDown={boundonKeyDown}
                    onBlur={boundOnBlur}
                    onFocus={boundOnFocus}
                    value={value}
                    onKeyPress={boundKeyPress}
                    placeholder={placeHolder}
                    required={required}
                    disabled={this.props.disabled}
                />
            </React.Fragment>
        );
    }
}